/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type JoblistingsSidebar_town_search_QueryVariables = {
    query?: string | null;
};
export type JoblistingsSidebar_town_search_QueryResponse = {
    readonly search: ReadonlyArray<({
        readonly __typename: "Town";
        readonly name: string;
        readonly id: string;
    } | {
        /*This will never be '%other', but we need some
        value in case none of the concrete values match.*/
        readonly __typename: "%other";
    }) | null>;
};
export type JoblistingsSidebar_town_search_Query = {
    readonly response: JoblistingsSidebar_town_search_QueryResponse;
    readonly variables: JoblistingsSidebar_town_search_QueryVariables;
};



/*
query JoblistingsSidebar_town_search_Query(
  $query: String
) {
  search(query: $query, types: [TOWNS_WITH_JOBLISTING]) {
    ... on Town {
      name
      id
    }
    __typename
    ... on Node {
      __isNode: __typename
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "query"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "query",
    "variableName": "query"
  },
  {
    "kind": "Literal",
    "name": "types",
    "value": [
      "TOWNS_WITH_JOBLISTING"
    ]
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    (v3/*: any*/)
  ],
  "type": "Town",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "JoblistingsSidebar_town_search_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "search",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "JoblistingsSidebar_town_search_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "search",
        "plural": true,
        "selections": [
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/)
            ],
            "type": "Node",
            "abstractKey": "__isNode"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "92ad3f82cd20eaba53a218ef8f009361",
    "id": null,
    "metadata": {},
    "name": "JoblistingsSidebar_town_search_Query",
    "operationKind": "query",
    "text": "query JoblistingsSidebar_town_search_Query(\n  $query: String\n) {\n  search(query: $query, types: [TOWNS_WITH_JOBLISTING]) {\n    ... on Town {\n      name\n      id\n    }\n    __typename\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '353a15a0bc419894182a90f3b196a145';
export default node;
